import { Button } from '@material-ui/core';
import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Notice } from 'services';
import { CreateModal, Results } from './components';

const NoticeList = props => {
  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Notices" subheader="Notices Management" {...rest}>
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Notice
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Notice.list}
      title="Notices"
      name="notices"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      roles={[]}
      filters={{ limit: 10, offset: 0, count: 0, search: "" }}
    />
  );
};

export default NoticeList;
